module.exports = __webpack_public_path__ + "static/img/27.81be744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/27.png
// module id = xkee
// module chunks = 1